import { actionTypeKeys } from "../actions/actionTypeKeys";
import { CustomerPreferences } from "../types/customer";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";

export default function userPreferenceReducer(
  state: CustomerPreferences | null = initialState.customerPreferences,
  action: AnyAction
) {
  switch (action.type) {
    case actionTypeKeys.LOAD_CUSTOMER_PREFERENCES_SUCCESS:
      return { ...action.preferences };
    case actionTypeKeys.CUSTOMER_PREFERENCES_UPDATED_SUCCESS:
      return { ...action.preferences };
    case actionTypeKeys.LOGOUT_SUCCESS:
      return { ...initialState.customerPreferences };
    default:
      return state;
  }
}
